import React, { useEffect, useState } from 'react';
import StateDropdown from './StateDropdown';
import CountryDropdown from './CountryDropdown';
import { Country, State } from 'country-state-city';

const FilterSection = ({ onFilterChange }) => {

    const [states, setStates] = useState([]);

    const [selectedState, setSelectedState] = useState('');
    const [selectedGame, setSelectedGame] = useState('');
    const [search, setSearch] = useState('');
    const [countryCodeMap, setCountryCodeMap] = useState({});
    const [stateCodeToNameMap, setStateCodeToNameMap] = useState({});
    const [selectedSort, setSelectedSort] = useState('');
    const [countryReset, setCountryReset] = useState(false);

    const games = ['8-Ball', '9-Ball', 'Snooker', 'English Pool', 'Straight', 'Golf', 'Pickleball', '10-Ball', 'English Billiards', 'Billiards Golf']


    useEffect(() => {

        const countryList = Country.getAllCountries();
        const countryMap = countryList.reduce((acc, country) => {
            acc[country.name] = country.isoCode;
            return acc;
        }, {});
        setCountryCodeMap(countryMap);

    }, []);

    const handleSortChange = (sort) => {
        setSelectedSort(sort);

        let sortLabel = '';

        switch (sort) {
            case 'A-Z':
                sortLabel = '1';
                break;
            case 'Z-A':
                sortLabel = '2';
                break;
            case 'Low-High':
                sortLabel = '3';
                break;
            case 'High-Low':
                sortLabel = '4';
                break;
            default:
                sortLabel = '';
        }

        onFilterChange({ sort: sortLabel });
    };

    const handleCountryChange = (countryName) => {
        const countryCode = countryCodeMap[countryName];
        if (!countryName) {
            setStates([]);
            setSelectedState('');
            onFilterChange({ country: '', state: '', game: selectedGame, search });
            return;
        }
        if (countryCode) {
            const stateList = State.getStatesOfCountry(countryCode);
            const sortedStateList = stateList.sort((a, b) => a.name.localeCompare(b.name));
            setStates(sortedStateList);
            setStateCodeToNameMap(stateList.reduce((acc, state) => {
                acc[state.isoCode] = state.name;
                return acc;
            }, {}));
            setSelectedState('');
            onFilterChange({ country: countryName, state: '', game: selectedGame, search });
        }
    };

    const handleStateChange = (event) => {
        const stateCode = event.target.value;
        const stateName = stateCodeToNameMap[stateCode] || '';
        setSelectedState(stateName);
        onFilterChange({ state: stateName, country: '', game: selectedGame, search });
    };


    const handleGameChange = (event) => {
        const game = event.target.value;
        setSelectedGame(game);
        onFilterChange({ game, country: '', state: selectedState, search });
    };

    const handleSearchChange = (event) => {
        const search = event.target.value;
        setSearch(search);
        onFilterChange({ search, country: '', state: selectedState, game: selectedGame });
    };

    const handleReset = () => {

        setStates([]);
        setSelectedState('');
        setSelectedGame('');
        setSearch('');
        setSelectedSort('');
        setCountryReset((prevState) => !prevState);

        onFilterChange({ country: '', state: '', game: '', search: '', sort: '' });



    };

    function scrollWinRight() {
        var fliterdiv = document.querySelector(".filter-wrapper");
        fliterdiv.scrollLeft += 100;
    }
    function scrollWinLeft() {
        var fliterdiv = document.querySelector(".filter-wrapper");
        fliterdiv.scrollLeft -= 100;
    }

    return (
        <div className="filter-section p-relative spacer">
            <div className="row">
                <div className="col-12">
                    <div className="filter-wrapper">
                        <div className="search-blk p-relative">
                            <input type="search" id="search" className="form-control" placeholder="search" value={search} onChange={handleSearchChange} />
                            <span className="search-icon" />
                        </div>
                        <div className="select-blk">
                            <select id="selectGame" className="form-select" onChange={handleGameChange} value={selectedGame}>
                                <option value="">Select Game</option>
                                {games.map((game) => (
                                    <option key={game} value={game}>{game}</option>
                                ))}
                            </select>
                        </div>
                        <div className="select-blk multifilter">
                            <select id="selectMulti" className="form-select" value={selectedSort} onChange={(e) => handleSortChange(e.target.value)}>
                                <option value="">Sort By:</option>
                                <option value="A-Z">A-Z</option>
                                <option value="Z-A">Z-A</option>
                                <option value="Low-High">Low-High</option>
                                <option value="High-Low">High-Low</option>
                            </select>
                        </div>
                        <div className="select-blk">
                            <CountryDropdown onCountryChange={handleCountryChange} countryReset={countryReset} />
                        </div>
                        <div className="select-blk">
                            <StateDropdown states={states} selectedState={selectedState} onStateChange={handleStateChange} />
                        </div>
                        <div className='reset-button'>
                            <button className='btn btn-sm btn-primary' onClick={handleReset} >Reset</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="scrollbtn-blk">
                <button onClick={() => scrollWinLeft()}><i className="fa-solid fa-chevron-left" /></button>
                <button onClick={() => scrollWinRight()}><i className="fa-solid fa-chevron-right" /></button>
            </div>

        </div>
    );
};

export default FilterSection;
